import { IntakeLabelCollection } from '../../entities/intake-label.interface';

export const IesMySituationLabels: IntakeLabelCollection = {
  onBehalf: {
    label: 'Are you applying for yourself or somebody else?',
    thirdPersonLabel: 'Are you (<<applicantName>>) applying for yourself or somebody else?',
  },
  isCompletedOnBehalf: {
    label:
      'Would you like to name an individual or organization the Income Support program can contact, or who can contact the Income Support program, about your application?',
    thirdPersonLabel:
      'Would <<applicantName>> like to name an individual or organization the Income Support program can contact, or who can contact the Income Support program, about <<genderApplicantHisHer>> application?',
  },
  movedToAlberta: {
    label: 'Did you move to Alberta within the last year?',
    thirdPersonLabel: 'Did <<applicantName>> move to Alberta within the last year?',
  },
  onBehalfName: {
    label: 'Name/organization',
  },
  onBehalfPhoneNumber: {
    label: 'Phone number',
  },
  onBehalfEmail: {
    label: 'Email',
  },
  isMovedToAlberta: {
    label: 'Did you move to Alberta within the last year?',
    thirdPersonLabel: 'Did <<applicantName>> move to Alberta within the last year?',
  },
  movedFromLocation: {
    label: 'Where did you move from?',
    thirdPersonLabel: 'Where did <<applicantName>> move from?',
  },
  movedToAlbertaDate: {
    label: 'Arrival Date In Alberta',
  },
  municipality: {
    label: 'What is the name of the city/town where you currently live?',
    thirdPersonLabel: 'What is the name of the city/town where <<applicantName>> currently lives?',
  },
  hasFinancialAdmin: {
    label: 'Do you have a Financial Administrator?',
    thirdPersonLabel: 'Does <<applicantName>> have a Financial Administrator?',
  },
  financialAdminName: {
    label: 'Name/Organization',
  },
  financialAdminPhone: {
    label: 'Phone number',
  },
  financialAdminEmail: {
    label: 'Email address',
  },
  isEvictionDue: {
    label: 'Do you have an eviction notice that requires you to move out within the next 5 days?',
    thirdPersonLabel:
      'Does <<applicantName>> have an eviction notice that requires <<genderApplicantHimHer>> to move out within the next 5 days?',
  },
  isUtilityCutOffDue: {
    label: 'Are your utilities being cut-off within the next 5 days? e.g. power, gas, water.',
    thirdPersonLabel: `Is <<applicantName>>'s utilities being cut-off within the next 5 days? e.g. power, gas, water.`,
  },
  hasMedicalNeed: {
    label: 'Do you have an immediate medical need that requires financial support?',
    thirdPersonLabel: 'Does <<applicantName>> have an immediate medical need that requires financial support?',
  },
  hasDentalNeed: {
    label: 'Do you require financial support for an immediate dental problem?',
    thirdPersonLabel: 'Does <<applicantName>> require financial support for an immediate dental problem?',
  },
  leavingAbusiveSituation: {
    label: 'Are you leaving an abusive situation?',
    thirdPersonLabel: 'Is <<applicantName>> leaving an abusive situation?',
  },
  maritalStatus: {
    label: 'What is your marital status?',
    thirdPersonLabel: `What is <<applicantName>>'s marital status?`,
  },
  hasDependentChild: {
    label: 'Do you have dependent child(ren) who live with you?',
    thirdPersonLabel: 'Does <<applicantName>> have dependent child(ren) who lives with <<genderApplicantHimHer>>?',
  },
};
